export default "__VITE_ASSET__BOWm_wgr__"